// extracted by mini-css-extract-plugin
export var center = "_3q-2";
export var clickableRow = "_3q-5";
export var expandedRow = "_3q-7";
export var hoverable = "_3q-4";
export var left = "_3q-1";
export var right = "_3q-3";
export var row = "_3q-0";
export var selectedRow = "_3q-6";
export var summaryRow = "_3q-8";